import { render, staticRenderFns } from "./BaseElDialog.vue?vue&type=template&id=161219be&"
import script from "./BaseElDialog.vue?vue&type=script&lang=js&"
export * from "./BaseElDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports